import { render } from "./Existencias.vue?vue&type=template&id=d0077108"
import script from "./Existencias.vue?vue&type=script&lang=js"
export * from "./Existencias.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__